import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import { TooltipBody, TooltipTrigger } from '../../../../infra/ui/tooltip';
import NotesIcon from '../icons/notes.svg';
export var WalkInNotes = function (_a) {
    var appointmentNote = _a.appointmentNote, customerNote = _a.customerNote;
    if (!appointmentNote && !customerNote) {
        return null;
    }
    return (_jsxs(TooltipTrigger, { className: styles['icon-btn'], children: [_jsx(NotesIcon, { className: "".concat(styles['icon-black'], " ").concat(styles['icon-tooltip']) }), _jsx(TooltipBody, { children: _jsxs("div", { className: styles['note-tooltip'], children: [appointmentNote && (_jsxs("div", { children: [_jsx("div", { className: styles['note-tooltip-header'], children: "Appointment note" }), _jsx("div", { className: styles['note-tooltip-text'], children: appointmentNote })] })), customerNote && (_jsxs("div", { children: [_jsx("div", { className: styles['note-tooltip-header'], children: "Client note" }), _jsx("div", { className: styles['note-tooltip-text'], children: customerNote })] }))] }) })] }));
};
WalkInNotes.defaultProps = {
    appointmentNote: null,
    customerNote: null,
};
